import { useQuery } from "@tanstack/react-query";
import { useTreasuryClient } from "./client";

export const STATUS_COLOR = {
  complete: "text-success",
  COMPLETE: "text-success",
  invalid: "text-error",
  INVALID: "text-error"

};

export function usePurchase(id) {
  let treasury = useTreasuryClient();
  return useQuery({
    queryKey: [ "GET", treasury.url, "/purchase", `/${id}`],
    queryFn: async function getPurchaseQueryFn() {
      return await treasury.getPurchase(id)

    },
    refetchOnWindowFocus: "always",
    refetchOnMount: "always",
    refetchOnReconnect: "always",
  })
}

export function usePurchaseList() {
  let treasury = useTreasuryClient()
  return useQuery({
    queryKey: [ "GET", treasury.url, "/purchase" ],
    queryFn: async function getPurchaseListQueryFn() {
      return treasury.getPurchase();
    }
  });
}
